import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api.js';

export function UploadList({ sessionId }: { sessionId: string }) {
  const { data, isLoading, error } = useQuery({
    queryKey: ['uploads', sessionId],
    queryFn: () => api.listUploads(sessionId),
    refetchInterval: 5000,
  });

  if (isLoading) {
    return <div className="text-[11px]" style={{ color: 'var(--text-dimmed)' }}>Loading uploads…</div>;
  }
  if (error) {
    return <div className="text-[11px]" style={{ color: 'var(--accent-red)' }}>Error: {String(error)}</div>;
  }
  const rows = data?.uploads ?? [];
  if (rows.length === 0) {
    return <div className="text-[11px]" style={{ color: 'var(--text-dimmed)' }}>No uploads yet.</div>;
  }

  return (
    <div className="space-y-1">
      {rows.map((u) => (
        <div
          key={u.id}
          className="flex items-center justify-between rounded-lg px-3 py-2 text-[12px]"
          style={{ background: 'var(--bg-tertiary)', border: '1px solid var(--border)' }}
        >
          <div className="flex items-center gap-3 min-w-0">
            <span className="font-mono truncate" style={{ color: 'var(--text-primary)' }}>{u.filename}</span>
            <span className="shrink-0" style={{ color: 'var(--text-dimmed)' }}>
              {(u.sizeBytes / 1024).toFixed(1)} KB
              {u.headers ? ` · ${u.headers.length} cols` : ''}
              {u.rowCountEstimate != null ? ` · ~${u.rowCountEstimate} rows` : ''}
            </span>
          </div>
          <span className="shrink-0 font-mono text-[10px]" style={{ color: 'var(--text-dimmed)' }}>
            {new Date(u.createdAt).toLocaleString()}
          </span>
        </div>
      ))}
    </div>
  );
}
